import React from 'react';
import moment from 'moment';
import QRCode from 'qrcode.react';
import styles from './index.css';

export default class NovelReader extends React.Component {
    render() {
        const { add_time, title, word_num, content, is_enough_egold, font_size, children } = this.props;
        return (
            <div style={{ padding: '20px', position: 'relative' }}>
                {children}
                <div style={{
                    fontSize: '26px',
                    lineHeight: '37px',
                }}>{title}</div>
                <div className={styles.light} style={{
                    fontSize: '12px',
                    lineHeight: '17px',
                    marginTop: '17px',
                }}>{is_enough_egold ? `${moment(1000 * add_time).format('MM-DD HH:mm')}发布 | ${word_num}字` : ''}</div>
                <div className={styles.content} style={{
                    fontSize: font_size ? `${font_size}px` : '18px',
                }} dangerouslySetInnerHTML={{
                    __html: content,
                }} />
                {is_enough_egold === false &&
                    <div style={{
                        textAlign: 'center',
                    }}>
                        {/* <div style={{
                            fontSize: '20px',
                            lineHeight: '28px',
                        }}>下载万读APP，继续阅读精彩内容</div>
                        <div style={{
                            marginTop: '20px',
                        }}>
                            <QRCode
                                value="//t.10000read.com/attention/appdownload?from=pc_download"
                                size={106}
                            />
                        </div>
                        <div style={{
                            marginTop: '10px',
                        }}>扫一扫下载</div> */}

                        <div style={{
                            fontSize: '20px',
                            lineHeight: '28px',
                        }}>暂不可阅读</div>
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layout/book/read/novel_reader.js